var _defs, _path, _path2, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 1200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#707070;}.cls-2{fill:none;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "account-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M600,528c-137.3,0-249-111.71-249-249S462.7,30,600,30,849,141.71,849,279,737.3,528,600,528Zm0-432.36c-101.1,0-183.35,82.25-183.35,183.35S498.9,462.36,600,462.36,783.35,380.11,783.35,279,701.1,95.66,600,95.66Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1032.4,1170H167.68a32.83,32.83,0,0,1-32.83-32.83v-190c0-191.48,155.79-347.26,347.27-347.26H718c191.49,0,347.27,155.78,347.27,347.26v190a32.83,32.83,0,0,1-32.83,32.83Zm-831.89-65.66H999.58V947.19c0-155.28-126.33-281.61-281.62-281.61H482.13c-155.29,0-281.62,126.33-281.62,281.61Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 1200,
    height: 1200
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountIcon);
export default __webpack_public_path__ + "static/media/account-icon.976a4586c5a221267e281c9eb9aadf8c.svg";
export { ForwardRef as ReactComponent };